<template>
  <div class="sandglass">
    <div ref="sandglassInner" id="sandglass-inner">
      <div class="sandglass__half sandglass">

        <svg viewBox="0 0 512 512" class="sandglass-svg" :class="isWorkTime ? 'work' : 'break'">
            <!-- 枠 -->
            <path fill="#9B92C3" d="M427.574,452.086h-2.722v-32.554c0-50.214-22.661-97.633-63.801-133.512l-24.707-21.546l-2.242-1.957l-2.617-1.426c-3.45-1.882-4.676-3.918-4.676-5.09c0-1.168,1.226-3.203,4.676-5.086l2.617-1.426l2.242-1.957l24.703-21.543c41.144-35.882,63.805-83.301,63.805-133.515V59.918h2.722c16.546,0,29.957-13.414,29.957-29.957C457.531,13.414,444.121,0,427.574,0H84.426C67.879,0,54.469,13.414,54.469,29.961c0,16.543,13.41,29.957,29.957,29.957h2.723v32.555c0,50.214,22.66,97.633,63.801,133.511l24.706,21.547l2.242,1.957l2.618,1.426c3.449,1.882,4.675,3.918,4.675,5.086c0,1.172-1.226,3.207-4.675,5.09l-2.618,1.426l-2.242,1.957l-24.703,21.543c-41.144,35.882-63.804,83.301-63.804,133.515v32.554h-2.723c-16.546,0-29.957,13.414-29.957,29.958c0,16.546,13.41,29.957,29.957,29.957h343.149c16.546,0,29.957-13.41,29.957-29.957C457.531,465.5,444.121,452.086,427.574,452.086z M114.793,409.562c0.297-4.023,0.758-8.027,1.41-12.004c0.149-0.934,0.313-1.859,0.481-2.789c0.832-4.504,1.87-8.973,3.144-13.39c0.102-0.348,0.203-0.696,0.305-1.043c4.402-14.813,11.274-29.047,20.422-42.289c0.122-0.172,0.238-0.344,0.36-0.516c2.863-4.11,5.961-8.114,9.258-12.019c0.473-0.562,0.953-1.122,1.438-1.68c3.031-3.496,6.246-6.894,9.617-10.199c0.867-0.848,1.742-1.683,2.629-2.519c1.637-1.539,3.282-3.078,4.997-4.57L193.554,285c25.161-13.722,25.161-44.274,0-57.996l-24.702-21.543c-1.715-1.492-3.36-3.031-4.997-4.57c-0.886-0.836-1.762-1.672-2.629-2.519c-3.371-3.305-6.586-6.703-9.617-10.199c-0.485-0.558-0.965-1.118-1.438-1.68c-3.297-3.906-6.394-7.91-9.258-12.015c-0.122-0.176-0.238-0.348-0.36-0.524c-9.148-13.238-16.019-27.472-20.422-42.285c-0.102-0.348-0.203-0.695-0.305-1.043c-1.274-4.414-2.312-8.886-3.144-13.39c-0.168-0.93-0.332-1.859-0.481-2.789c-0.652-3.977-1.114-7.981-1.41-12.004c-0.106-1.434-0.187-2.871-0.246-4.309c-0.078-1.882-0.164-3.77-0.164-5.66V59.918h283.234v32.555c0,1.89-0.086,3.778-0.165,5.66c-0.058,1.438-0.14,2.875-0.246,4.309c-0.297,4.023-0.758,8.027-1.41,12.004c-0.148,0.93-0.312,1.859-0.48,2.789c-0.832,4.504-1.871,8.977-3.145,13.39c-0.102,0.348-0.203,0.695-0.305,1.043c-4.402,14.813-11.274,29.047-20.422,42.285c-0.122,0.176-0.238,0.348-0.36,0.524c-2.863,4.106-5.961,8.109-9.258,12.015c-0.473,0.562-0.953,1.122-1.438,1.68c-3.031,3.496-6.246,6.894-9.617,10.199c-0.867,0.847-1.742,1.683-2.629,2.519c-1.637,1.539-3.282,3.078-4.996,4.57l-24.703,21.543c-25.16,13.722-25.16,44.274,0,57.996l24.703,21.543c1.714,1.492,3.359,3.031,4.996,4.57c0.886,0.836,1.762,1.671,2.629,2.519c3.371,3.305,6.586,6.703,9.617,10.199c0.485,0.558,0.965,1.118,1.438,1.68c3.297,3.906,6.394,7.91,9.258,12.019c0.122,0.172,0.238,0.344,0.36,0.516c9.148,13.242,16.019,27.476,20.422,42.289c0.102,0.347,0.203,0.695,0.305,1.043c1.274,4.418,2.313,8.886,3.145,13.39c0.168,0.93,0.332,1.855,0.48,2.789c0.653,3.977,1.114,7.981,1.41,12.004c0.106,1.434,0.187,2.871,0.246,4.309c0.078,1.886,0.165,3.77,0.165,5.66v32.554H114.383v-32.554c0-1.89,0.086-3.774,0.164-5.66C114.606,412.434,114.687,410.996,114.793,409.562z"/>
            <!-- 上の砂部分 -->
            <path id="sand" :class="isWorkTime ? 'sand-bottom' : 'sand-top'" :ref="isWorkTime ? 'bottomSand' : 'topSand'" :fill="isWorkTime ? '#E57373' : '#4FC3F7'" d="M147.063,100.484c0,35.242,16.18,68.794,45.481,94.34l22.496,19.606c18.902,11.66,30.066,29.906,30.066,49.57c0,19.66-11.164,37.906-30.066,49.562l-22.496,19.61c-16.336,14.222-28.528,30.922-36.153,49.027c-0.218,0.496-0.511,0.965-0.722,1.469h0.074c-0.024,0.054-0.051,0.106-0.074,0.16H301.82l54.363,0.058c-0.011-0.019-0.023-0.038-0.031-0.058h0.176c-7.57-18.738-20.043-36.004-36.875-50.656l-22.492-19.61c-18.902-11.656-30.066-29.902-30.066-49.562c0-19.664,11.164-37.91,30.066-49.57l22.492-19.606c29.305-25.546,45.485-59.098,45.485-94.34v-5.503H147.063V100.484z" />
            <!-- 下の砂部分 -->
            <path id="sand" :class="isWorkTime ? 'sand-top' : 'sand-bottom'" :ref="isWorkTime ? 'topSand' : 'bottomSand'" :fill="isWorkTime ? '#E57373' : '#4FC3F7'" d="M364.938,419.516c0-35.242-16.18-68.794-45.481-94.34l-22.496-19.606c-18.902-11.66-30.066-29.906-30.066-49.57c0-19.66,11.164-37.906,30.066-49.562l22.496-19.61c16.336-14.222,28.528-30.922,36.153-49.027c0.218-0.496,0.511-0.965,0.722-1.469h-0.074c0.024-0.054,0.051-0.106,0.074-0.16H210.18l-54.363-0.058c0.011,0.019,0.023,0.038,0.031,0.058h-0.176c7.57,18.738,20.043,36.004,36.875,50.656l22.492,19.61c18.902,11.656,30.066,29.902,30.066,49.562c0,19.664-11.164,37.91-30.066,49.57l-22.492,19.606c-29.305,25.546-45.485,59.098-45.485,94.34v5.503h217.875V419.516z" />
            <!-- 砂が流れる丸① -->
            <circle v-for="(n, index) in 10" :key="index" :style="{ animationDelay: `${index * 0.4}s` }" :class="[running ? 'sand-flow' : 'sand-stop', isWorkTime ? 'flow-up' : 'flow-down']" ref="sandFlow" :fill="isWorkTime ? '#E57373' : '#4FC3F7'" :cx="254 + index % 3 * 2" cy="250" :r="8 + index % 2 * 4" />
        </svg>
        
      </div>
    </div>
  </div> 
</template>

<script>
export default {
  props: {
    timeRemain: Number,
    timeMax: Number,
    running: Boolean,
    isWorkTime: Boolean,
  },
  data() {
    return {
      timer: null
    };
  },
  methods: {
    reset() {
        this.$refs.sandglassInner.style.transition = `transform 0 ease`;
        this.$refs.sandglassInner.style.transform = `rotate(0deg)`;
        this.$refs.topSand.style.clipPath = `inset(60% 0% 0% 0%)`;
        this.$refs.bottomSand.style.clipPath = `inset(100% 0% 0% 0%)`;
    },
    turnSandglass() {
        this.$refs.sandglassInner.style.transition = `transform 0.5s ease`;
        if (this.isWorkTime){
            this.$refs.sandglassInner.style.transform = `rotate(180deg)`;
        }else{
            this.$refs.sandglassInner.style.transform = `rotate(0deg)`;
        }
    },
    updateSand() {
      // 砂の減り具合（0〜1）
      const progress = 1 - this.timeRemain / this.timeMax;

      const topPercent = progress * 40 + 20;
      const bottomPercent = 100 - topPercent + 20;

      // 上下の砂の制御
      if (this.isWorkTime) {
        this.$refs.topSand.style.clipPath = `inset(40% 0% ${topPercent}% 0%)`;
        this.$refs.bottomSand.style.clipPath = `inset(0% 0% ${bottomPercent}% 0%)`;
      }else{
        this.$refs.topSand.style.clipPath = `inset(${topPercent}% 0% 40% 0%)`;
        this.$refs.bottomSand.style.clipPath = `inset(${bottomPercent}% 0% 0% 0%)`;
      }
    }
  }
};
</script>

<style scoped>
.sand-top {
    clip-path: inset(60% 0% 0% 0%);
}
.sand-bottom {
    clip-path: inset(100% 0% 0% 0%);
}

.sand-stop {
  opacity: 0;
}
.sand-flow.flow-up {
  animation: flow-up 4s infinite;
}
.sand-flow.flow-down {
  animation: flow-down 4s infinite;
}
@keyframes flow-up {
  0% {
    transform: translate(0, 0);
    opacity: 0.8;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    transform: translate(0px, -150px);
    opacity: 0;
  }
}
@keyframes flow-down {
  0% {
    transform: translate(0, 0);
    opacity: 0.8;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    transform: translate(0px, 150px);
    opacity: 0;
  }
}

.sandglass {
    width: 250px;
    height: 250px;
    margin: auto;
    margin-top: 60px;
    margin-bottom: 60px;
}

</style>